import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';

import { ChannelType } from '../types';

import { channelsQueryKeys } from './query-keys';

export async function getChannelId(id: string): Promise<ChannelType> {
  return mediaManagerClient.get(`/api/v1/channels/${id}`).then(res => {
    if (!res.data) {
      return res;
    } else {
      return res.data;
    }
  });
}

type QueryFnType = typeof getChannelId;

interface useChannelIdParams {
  config?: QueryConfig<QueryFnType>;
  id?: string;
}

export function useChannelId({ id, config }: useChannelIdParams) {
  return useQuery({
    ...config,
    enabled: !!id,
    queryKey: channelsQueryKeys.id(id),
    queryFn: () => {
      if (!id) {
        throw new Error('Channel id is required');
      }

      return getChannelId(id);
    },
  });
}
